/**
 * M21 #7 — 1차 검수 완료/해제 mutation 훅.
 *
 * 완료 처리 시 백엔드가 최종 AI 검토(chat-vl-pro)를 비동기로 실행하므로,
 * 성공 후 Job 상세를 무효화해 review_status/ai_review 를 폴링으로 반영한다.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { jobDetailKey } from "@/features/jobs/useJobDetail";
import {
  clearAutoFixChecked,
  clearReviewComplete,
  clearReviewConfirmed,
  setAutoFixChecked,
  setReviewComplete,
  setReviewConfirmed,
} from "@/lib/api/records";
import type { RecordOut } from "@/lib/api/jobs";

interface Variables {
  jobId: string;
  fileId: string;
}

export function useSetReviewComplete() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => setReviewComplete(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}

export function useClearReviewComplete() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => clearReviewComplete(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}

export function useSetReviewConfirmed() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => setReviewConfirmed(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}

export function useClearReviewConfirmed() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => clearReviewConfirmed(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}

/** 자동 검수가 고친 값 확인함 / 취소. */
export function useSetAutoFixChecked() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => setAutoFixChecked(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}

export function useClearAutoFixChecked() {
  const qc = useQueryClient();
  return useMutation<RecordOut, Error, Variables>({
    mutationFn: ({ jobId, fileId }) => clearAutoFixChecked(jobId, fileId),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: jobDetailKey(vars.jobId) });
    },
  });
}
